import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { useParams } from 'react-router-dom';
import { PickFolderDialog } from 'app/domains/common-ui/pickers';
import { MoveEntryConfirmation } from 'app/domains/filesystem';
import { EntryKind } from 'shared/domains/apollo/generated/types';
export function MoveDialog(props) {
    const { payload, parentId, onClose } = props;
    const { folderId } = useParams();
    const sourceId = payload.id;
    const { addToast } = useToast();
    const [targetId, setTargetId] = useState();
    const handleSelectTargetEntry = (entry) => {
        if (entry.id === sourceId) {
            addToast({
                appearance: 'info',
                title: t({
                    message: 'You can not move an folder into itself',
                    comment: 'Move document/folder dialog error toast',
                }),
            });
            return;
        }
        setTargetId(entry.id);
    };
    const subtitle = t({
        comment: 'Move document/folder dialog subtitle',
        message: 'Select a destination folder',
    });
    if (targetId) {
        return <MoveEntryConfirmation sourceId={sourceId} targetId={targetId} onClose={onClose}/>;
    }
    const selectable = (entry) => {
        const isSelf = entry.id === sourceId;
        const isFolder = entry.kind === EntryKind.Folder;
        return !isSelf && isFolder;
    };
    return (<PickFolderDialog initialFolderId={parentId || folderId} dialogTitle={t({
            comment: 'Move document/folder dialog title',
            message: `Move`,
        })} dialogSubtitle={subtitle} submitLabel={t({ comment: 'Move entry dialog submit label', message: 'Move' })} onSubmit={handleSelectTargetEntry} onClose={onClose} selectable={selectable}/>);
}
